const ITEMS = [
  "Romanico Pugliese",
  "Gotico Angioino",
  "Pietra Leccese",
  "Affreschi del Quattrocento",
  "Raimondello Orsini del Balzo",
  "Basilica Minore",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative bg-espresso py-5 overflow-hidden border-y border-gold/20"
      aria-hidden="true"
    >
      <div className="marquee-track flex items-center gap-10 w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-serif text-xl sm:text-2xl italic text-ivory/70 whitespace-nowrap">
                  {item}
                </span>
                <span className="diamond opacity-60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
